<template>
    <section class="px-content py-20 xl:pt-[96px] xl:pb-[120px] will-change" :class="computedClass" :data-scroll-section="inner == 'false'">
        <h2 class="text-4xl xl:text-heading mb-8 text-center" v-show="blockData.title">{{ blockData.title }}</h2>
        <div class="mx-auto xl:max-w-[40vw] leading-normal text-center" v-show="blockData.text" v-html="blockData.text"></div>

        <div class="flex flex-wrap items-center justify-center">
            <div class="flex flex-col items-center self-start mt-14 px-2 sm:px-4 w-1/2 sm:w-1/5"  v-show="blockData.icons" v-for="(i, index) in blockData.icons" :key="index+i.title">
                <img class="mb-4 w-16 xl:w-20" v-show="i.icon" :src="i.icon.url" :alt="i.icon.alt">
                <div class="text-center" v-show="i.title" v-html="i.title"></div>
            </div>
        </div>
    </section>
</template>


<script>
    export default {
        name: 'TextIcons',
        data() {
            return {}
        },
        mounted() {

        },
        methods: {

        },
        computed: {
            computedClass() {
                let className = '';
                if ( this.blockData.background_color === 'transparent' ) {
                    className = [
                        'bg-transparent'
                    ]
                }
                if ( this.blockData.background_color === 'light-blue' ) {
                    className = [
                        'bg-light-blue-03'
                    ]
                }
                return className;
            }
        }
    }
</script>
